'use client'

import styled from "styled-components";

import {getColorStyles} from "@/components/UI/Description/options/color.options";
import {getSizeStyles} from "@/components/UI/Description/options/size.options";

export const DescriptionStyled = styled.p`
    ${getColorStyles}
    ${getSizeStyles}
    ${({ $weight }) => $weight && `font-weight: ${$weight};`}
`
